import React, { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/pages/login";


//Doctor
import DoctorList from "./components/doctor/DoctorList";
import AddDoctor from "./components/doctor/AddDoctor";
import EditDoctor from "./components/doctor/EditDoctor";
import DoctorProfile from "./components/doctor/DoctorProfile";
//Patients...
import PatientsList from "./components/patients/PatientsList";
import AddPatients from "./components/patients/AddPatients";
import EditPatients from "./components/patients/EditPatients";



import AddSchedule from "./components/doctorschedule/AddSchedule";

import ForgotPassword from "./components/pages/login/ForgotPassword";

import Register from "./components/pages/login/Register";
import LockScreen from "./components/pages/login/LockScreen";
import ChangePassword from "./components/pages/login/ChangePassword";
import Error from "./components/pages/login/Error";
import ServerError from "./components/pages/login/ServerError";

import Profile from "./components/pages/login/Profile";
import EditProfile from "./components/pages/login/EditProfile";
import BlankPage from "./components/pages/login/BlankPage";
import Doctor_Dashboard from "./components/Dashboard/Doctor_Dashboard/Doctor_Dashboard";
import Admin_Dashboard from "./components/Dashboard/Admin_Dashboard/Admin_Dashboard";
import Doctor_Settings from "./components/Dashboard/Doctor_Dashboard/Doctor_Settings";
import Patient_Settings from "./components/patients/Patient_Settings";

import GalleryImage from "./components/pages/Gallery/Gallery";
import HospitalList from "./components/Hospitals/HospitalList";
import AddHospital from "./components/Hospitals/AddHospital";
import EditHospital from "./components/Hospitals/EditHospital";
import HospitalProfile from "./components/Hospitals/HospitalProfile";

import ProtectedRoute from "./services/ProtectedRoute";
import Receptionistlist from "./components/reception/ReceptionistList";
import AddReceptionist from "./components/reception/AddReceptionist";
import EditReceptionist from "./components/reception/EditReceptionist";
import ReceptionistProfile from "./components/reception/ReceptionistProfile";
import Receptionist_Dashboard from "./components/Dashboard/Receptionist_Dashboard/Receptionist_Dashboard";
import AppointmentBooking from "./components/appointmentBooking/AppointmentBooking";
import AppointmentScheduler from "./components/appointmentBooking/AppointmentScheduler";
import PatientsProfile from "./components/Dashboard/Patient_Dashboard/PatientsProfile";
import ManageShifts from "./components/doctorschedule/ManageShifts";
import ConsultationFeeComponent from "./components/doctorschedule/ConsultationFee";
import MedicalConsultation from "./components/consultant/MedicalConsultation";
import AppointmentSettings from "./components/appointmentSettings/AppointmentSettings";
import Medicines from "./components/doctorSettings/Medicines";
import Symptoms from "./components/doctorSettings/Symptoms";
import Findings from "./components/doctorSettings/Findings";
import Diagnoses from "./components/doctorSettings/Diagnosis";
import Investigations from "./components/doctorSettings/investigations";
import Instructions from "./components/doctorSettings/Instructions";
import Procedures from "./components/doctorSettings/Procedures";
import MedicineModal from "./components/doctorSettings/MedicineForm";
import { useAuth } from "./services/authentication_API/authService";
import { message, Spin } from "antd";
import Doctor_Profile from "./components/Dashboard/Doctor_Dashboard/Doctor_Profile";
import Receptionist_Profile from "./components/Dashboard/Receptionist_Dashboard/Receptionist_Profile";
import PreviewRX from "./components/consultant/PreviewRX";
import { MessageProvider } from "./services/message api/MessageProvider";
import PrintSettings from "./components/doctor/PrintSettings";
import MedicalHistory from "./components/consultant/medicalHistory";
import Fees from "./components/doctorSettings/Fees";
import PreviewCertificate from "./components/certificate/PreviewCetificate";
import SelectModulesAndData from "./components/doctorSettings/ModuleData";
import Vaccines from "./components/vaccination/Vaccines";
import VaccineBoard from "./components/vaccination/VaccineConsult";
import Printcertificate from "./components/certificate/Print-certificate";
import PharmacistList from "./components/pharmacies/PharmaciesList";
import AddPharmacist from "./components/pharmacies/AddPharmaciest";
import EditPharmaciest from "./components/pharmacies/EditPharmaciest";
import LabsList from "./components/labs/LabsList";
import AddLabs from "./components/labs/AddLabs";
import EditLabs from "./components/labs/EditLabs";
import LabDashboard from "./components/Dashboard/Lab_Dashboard/Lab_Dashboard";
import Pharmacy_Dashboard from "./components/Dashboard/Pharmacy_Dashboard/Pharmacy_Dashboard";
import Pharmacy_Profile from "./components/Dashboard/Pharmacy_Dashboard/Pharmacy_Profile";
import Lab_Profile from "./components/Dashboard/Lab_Dashboard/Lab_Profile";
import AnalyticsData from "./components/analytics/AnalyticsData";

//Accounts
const Approuter = () => {

  const {user, token}=useAuth()
  // console.log(user,   token)

  const [loading, setLoading] = useState(true);
  const [token1, setToken] = useState('');
const [user1, setUser] = useState('');
  const [messageApi, contextHolder] = message.useMessage();
  
  useEffect(() => {
    
    if (token && user) {
      setToken(token);
      setUser(user);
    }
  
    // Done initializing
    setLoading(false);
  }, []);
  return (
    <>
    {loading ? (
      <div className="center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spin tip="Loading" size="large" />
    </div>
    ) : (
      <MessageProvider>
      <BrowserRouter >
  
      
         {/* unauthorized route */}
          {(!token || token.trim() === "") && !user ? (
            <Navigate to="/login" replace />
          ) : null}

        <Routes>
         

           <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute />}>

          {/* <Route path="/login" element={<Navigate to="/"/>} /> */}

          {user === "superadmin" && (
            <>
            <Route path="/" element={<Admin_Dashboard />} />
            <Route path="/admin-dashboard" element={<Admin_Dashboard />} />
             {/* Doctor  */}
            <Route path="/doctorlist" element={<DoctorList />} />
            <Route path="/add-doctor" element={<AddDoctor />} />
            <Route path="/editdoctor" element={<EditDoctor />} />
            <Route path="/doctorprofile" element={<DoctorProfile />} />
            <Route path="/doctor-setting" element={<Doctor_Settings />} />
            {/* Hospitals  */}
            <Route path="/hospitallist" element={<HospitalList />} />
            <Route path="/add-hospital" element={<AddHospital/>} />
            <Route path="/edithospital" element={<EditHospital />} />
            <Route path="/hospitalprofile" element={<HospitalProfile />} />
            <Route path="/hospital-setting" element={<Doctor_Settings />} />
            {/* <Route path="*" element={<Admin_Dashboard />} /> */}

            </>
          )}
          {user === "doctor" && (
            <>
            <Route path="/" element={<Doctor_Dashboard />} />
            <Route path="/receptionistlist" element={<Receptionistlist />} />
            <Route path="/add-receptionist" element={<AddReceptionist />} />
            <Route path="/edit-receptionist" element={<EditReceptionist />} />


            <Route path="/pharmacistlist" element={<PharmacistList />} />
            <Route path="/add-pharmacist" element={<AddPharmacist />} />
            <Route path="/edit-pharmacist" element={<EditPharmaciest />} />
            {/* <Route path="/pharmacistprofile" element={<PharmacistProfile />} /> */}

            <Route path="/labs" element={<LabsList />} />
            <Route path="/add-labs" element={<AddLabs />} />
            <Route path="/edit-labs" element={<EditLabs />} />

            <Route path="*" element={<Doctor_Dashboard />} />

            {/* Schedule */}
            <Route path="/addschedule" element={<AddSchedule />} />
            <Route path="/manage-shifts" element={<ManageShifts />} />
            <Route path="/consultantion-fee" element={<ConsultationFeeComponent />} />
            <Route path="/start-consult" element={<MedicalConsultation />} />
            <Route path="/Appointment-Settings" element={<AppointmentSettings />} />
            <Route path="/medicines-Settings" element={<Medicines />} />
            <Route path="/symptoms-Settings" element={<Symptoms />} />
            <Route path="/findings-Settings" element={<Findings />} />
            <Route path="/diagnoses-Settings" element={<Diagnoses />} />
            <Route path="/medicine-form" element={<MedicineModal />} />
            <Route path="/investigations-Settings" element={<Investigations />} />
            <Route path="/instructions-Settings" element={<Instructions />} />
            <Route path="/procedures-Settings" element={<Procedures />} />
            <Route path="/doctor-profile" element={<Doctor_Profile />} />
            <Route path="/preview-RX" element={<PreviewRX />} />
            <Route path="/preview-certificate" element={<PreviewCertificate />} />

            <Route path="/print-settings" element={<PrintSettings />} />
            <Route path="/medical-history" element={<MedicalHistory />} />
            <Route path="/fees-settings" element={<Fees />} />
            <Route path="/select-module" element={<SelectModulesAndData />} />
            <Route path="/vaccines" element={<Vaccines />} />
            <Route path="/vaccine-consult" element={<VaccineBoard />} />
            <Route path="/print-certificate" element={<Printcertificate />} />

            <Route path="/analytics" element={<AnalyticsData />} />

            </>
          )}

          {user === "receptionist" && (
            <>
            <Route path="/" element={<Receptionist_Dashboard />} />
            <Route path="*" element={<Receptionist_Dashboard/>} />
            {/* Patients */}
            <Route path="/patientslist" element={<PatientsList />} />
            <Route path="/addpatients" element={<AddPatients />} />
            <Route path="/editpatients" element={<EditPatients />} />
            <Route path="/patientsprofile" element={<PatientsProfile />} />
            <Route path="/patient-settings" element={<Patient_Settings />} />
            <Route path="/book-appoitment" element={<AppointmentBooking/>}/>
            <Route path="/book" element={<AppointmentScheduler/>}/>
            <Route path="/patient-profile" element={<PatientsProfile />} />
            <Route path="/receptionist-profile" element={<Receptionist_Profile />} />



            </>
          )}

          {user === "lab" && (
            <>
            <Route path="/" element={<LabDashboard />} />
            <Route path="*" element={<LabDashboard/>} />
            <Route path="/lab-profile" element={<Lab_Profile />} />
            </>
          )}

          {user === "pharmacy" && (
            <>
              <Route path="/" element={<Pharmacy_Dashboard />} />
              <Route path="*" element={<Pharmacy_Dashboard/>} />
              <Route path="/pharmacy-profile" element={<Pharmacy_Profile />} />
            </>
          )}

          {/* <Route path="*" element={<Navigate to="/"/>} /> */}
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/signup" element={<Navigate to="/"/>} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/register" element={<Register />} />
          <Route path="/lockscreen" element={<LockScreen />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/error" element={<Error />} />
          <Route path="/server-error" element={<ServerError />} />
          <Route path="/blankpage" element={<BlankPage />} />
          <Route path="/gallery" element={<GalleryImage />} />
          {/* Blog */}
     
          </Route>
        </Routes>
      </BrowserRouter>
      </MessageProvider>
      )}
      <div className="sidebar-overlay"></div>
    </>
  );
};

export default Approuter;


